import { ApplicationVersion } from '@models/application-version.model';
import { Context, createContext } from 'react';

export interface TestDevelopmentContextType {
  version: ApplicationVersion;
  setVersion: (version: ApplicationVersion) => void;
}

export const TestDevelopmentContext: Context<TestDevelopmentContextType> =
  createContext<TestDevelopmentContextType>({
    version: undefined,
    setVersion: () => {},
  });
